import type { Column } from "../types";

// Display-name overrides for shipment table columns. These win over whatever
// `name` is persisted in the user's saved column settings, so renames take
// effect immediately for existing users (whose backfilled columns still carry
// the original, longer names) without a settings reset.
const COLUMN_NAME_OVERRIDES: Record<string, string> = {
  invoicingExclTax: "Invoicing (excl. tax)",
  costExclTax: "Cost (excl. tax)",
  netProfitExclTax: "Net Profit (excl. tax)",
};

/** Resolved display name for a shipment column, applying any override. */
export const columnDisplayName = (column: Column): string =>
  COLUMN_NAME_OVERRIDES[column.id] ?? column.name;
